@if (!isMobile) {
<div class="modal-body d-none d-md-flex psic-p-8 w-100">
    <div class="content d-flex flex-column justify-content-center align-items-center w-100">
        @if (popupDispalyObj.type == 'actionDialog') {
        <div style="display: contents">
            @if (popupDispalyObj.imageSrc) {
            <img
                src="{{ popupDispalyObj.imageSrc }}"
                [ngStyle]="{
                    width: popupDispalyObj.imageWidth
                        ? popupDispalyObj.imageWidth
                        : popupDispalyObj.confirm === 'Download'
                        ? '120px'
                        : '64px',
                    height: popupDispalyObj.imageHeight || 'auto'
                }"
                alt="tick-img"
            />
            }
            <div class="psic-pt-1">
                <h5
                    class="text-center"
                    [ngClass]="{ 'title-style': popupDispalyObj.messageTitle }"
                    [innerHTML]="popupDispalyObj.messageTitle || popupDispalyObj.message"
                ></h5>
                <p
                    class="psic-pt-1 caption"
                    [ngClass]="{ 'caption-style': popupDispalyObj.messageSubtitle }"
                    [innerHTML]="popupDispalyObj.messageSubtitle || popupDispalyObj.messageExt"
                ></p>
            </div>
        </div>
        } @if (popupDispalyObj.type == 'paymentScehedule') {
        <div class="d-flex flex-row align-items-start">
            <div class="psic-ml-4 flex-column">
                <h5
                    class="text-center"
                    class="intro-quote-text psic-mb-4"
                    [innerHTML]="popupDispalyObj.message"
                ></h5>
                <p class="alt-bold" [innerHTML]="popupDispalyObj.messageExt"></p>
                @if (popupDispalyObj.fields.length > 0) {
                <ul class="psic-pt-4">
                    @for (item of popupDispalyObj.fields; track item; let i = $index) {
                    <li>
                        @if (i === 0) {
                        <span>
                            <p class="alt">${{ item.InstallmentNetAmount }} due today</p>
                        </span>
                        } @if (i > 0) {
                        <span>
                            <p class="alt">${{ item.InstallmentNetAmount }} due on {{ formatValue(item.DueDate) }}</p>
                        </span>
                        }
                    </li>
                    }
                </ul>
                }
                <p class="alt psic-pt-4">{{ popupDispalyObj.terms }}</p>
            </div>
        </div>
        } @if (popupDispalyObj.type == 'policyServicing') {
        <div class="d-flex flex-row align-items-start">
            <div class="ms-3 flex-column psic-mb-7">
                <h5 class="intro-quote-text text-center" [innerHTML]="popupDispalyObj.message"></h5>
                <p class="mt-3 alt-bold" [innerHTML]="popupDispalyObj.messageExt"></p>
                @if (popupDispalyObj.fields.length > 0) {
                <ul class="pt-3">
                    @for (item of popupDispalyObj.fields; track item; let i = $index) {
                    <li>
                        <p class="alt">${{ item.InstallmentNetAmount }} due on {{ formatValue(item.DueDate) }}</p>
                    </li>
                    }
                </ul>
                }
                <p class="alt pt-3">{{ popupDispalyObj.terms }}</p>
            </div>
        </div>
        } @if (popupDispalyObj.type == 'actionDialog') {
        <form [formGroup]="desktopForm">
            @if (popupDispalyObj.fields.length > 0) {
            <div class="d-flex flex-column align-items-start psic-mt-4">
                @for (field of popupDispalyObj.fields; track field; let i = $index) { @if (field.type == 'radio') {
                <div class="d-flex justify-content-center psic-mb-4 w-100">
                    <lib-input-radio
                        [formControlName]="field.name"
                        [field]="field"
                        [radioLeft]="true"
                    ></lib-input-radio>
                </div>
                } @if ((field.type == 'text' || field.type == 'email' || field.type == 'number') && (!field.showIf ||
                desktopForm.get(field.showIf.field)?.value === field.showIf.value)) {
                <div class="d-flex flex-row align-items-center psic-mb-4">
                    @if (field.name === 'effectiveDate') {
                    <mat-form-field style="min-width: 372px" appearance="fill" subscriptSizing="dynamic" floatLabel="always">
                        <mat-label class="disclaimer-bold">{{ field.caption }}</mat-label>
                        <input
                            matInput
                            type="text"
                            readonly
                            [placeholder]="field.placeholder || 'MM/DD/YYYY'"
                            [formControlName]="field.name"
                        />
                    </mat-form-field>
                    } @else {
                    <lib-input-text style="min-width: 372px" [formControlName]="field.name" [field]="field">
                    </lib-input-text>
                    }
                    @if (i + 1 < popupDispalyObj.fields.length && popupDispalyObj.fields[i + 1].type === 'button' &&
                    (!popupDispalyObj.fields[i + 1].showIf || desktopForm.get(popupDispalyObj.fields[i +
                    1].showIf.field)?.value === popupDispalyObj.fields[i + 1].showIf.value)) {
                    <div class="d-flex align-items-end w-auto psic-ml-4 psic-pt-5">
                        @if ((popupDispalyObj.fields[i + 1].name === 'verifyPhone' && verifyingPhone) || (popupDispalyObj.fields[i + 1].name === 'verifyEmail' && verifyingEmail)) {
                        <div class="d-flex align-items-center justify-content-center" style="width: 40px; height: 40px">
                            <span class="spinner-border spinner-border-sm text-primary" role="status"></span>
                        </div>
                        } @else {
                        <lib-button
                            [buttonType]="'borderless'"
                            [buttonText]="popupDispalyObj.fields[i + 1].caption"
                            [disabled]="
                                popupDispalyObj.fields[i + 1].name === 'verifyPhone'
                                    ? !desktopForm.controls['mobileNumber'].value
                                    : !desktopForm.controls['email'].value || !!desktopForm.controls['email'].invalid
                            "
                            [iconSrc]="popupDispalyObj.fields[i + 1].imageSrc"
                            (callback)="
                                popupDispalyObj.fields[i + 1].name === 'verifyPhone' ? verifyPhone() : verifyEmail()
                            "
                        >
                        </lib-button>
                        }
                    </div>
                    }
                </div>
                } @if (field.type == 'uploadDoc') {
                <div class="d-flex justify-content-center psic-mb-4 w-100">
                    <app-upload-doc [formControlName]="field.name" [field]="field"></app-upload-doc>
                </div>
                } }
            </div>
            } @if (popupDispalyObj.download === true && popupDispalyObj.summary === true) {
            <div class="psic-pt-4 psic-pb-4 d-flex justify-content-center">
                <lib-button
                    [buttonType]="'borderless'"
                    [buttonText]="'Download'"
                    [disabled]="false"
                    (callback)="footerButtonAction('Download')"
                ></lib-button>
            </div>
            }
        </form>
        }
        <div class="psic-mt-6 d-flex flex-row align-items-center">
            @if (popupDispalyObj.cancel) {
            <div class="psic-mr-5">
                <div class="d-flex psic-pr-9">
                    <lib-button
                        (callback)="footerButtonAction(popupDispalyObj.cancel)"
                        [disabled]="false"
                        [buttonTheme]="'primary'"
                        [buttonType]="'borderless'"
                        [buttonSize]="'medium'"
                        [buttonText]="popupDispalyObj.cancel"
                        [libIcon]="'back'"
                        [iconLeft]="true"
                    >
                    </lib-button>
                </div>
            </div>
            } @if (popupDispalyObj.confirm) {
            <div class="d-flex align-items-end">
                <lib-button
                    (callback)="footerButtonAction(popupDispalyObj.confirm)"
                    [disabled]="popupDispalyObj.type == 'actionDialog' && !isSaveEnabled"
                    [buttonSize]="'medium'"
                    [buttonText]="popupDispalyObj.confirm"
                ></lib-button>
            </div>
            } @if (popupDispalyObj.claimsButton) {
            <div>
                <div class="d-flex psic-pr-9">
                    <lib-button
                        (callback)="footerButtonAction(popupDispalyObj.claimsButton)"
                        [buttonSize]="'small'"
                        [buttonText]="popupDispalyObj.claimsButton"
                    ></lib-button>
                </div>
            </div>
            } @if (popupDispalyObj.policyButton) {
            <div class="d-flex align-items-end">
                <lib-button
                    (callback)="footerButtonAction(popupDispalyObj.policyButton)"
                    [buttonSize]="'small'"
                    [buttonText]="popupDispalyObj.policyButton"
                ></lib-button>
            </div>
            }
        </div>
    </div>
</div>
}
